export default {
  model (resource) {
    return Object.assign({
      title: '',
      reminder: false,
      completed: false,
      opportunityId: null,
      description: '',
      dueDate: null,
      type: '',
      status: 'En Proceso',
      phase: null
    }, resource)
  },
  rules () {
    return {
      description: [
        {required: true, message: 'La descripcion es requerida'},
        {min: 1, max: 255, message: 'La anotacion debe ser entre 1 y 255 carácteres'}
      ],
      type: [
        {required: true, message: 'El tipo es requerido'}
      ],
      phase: [
        {required: true, message: 'La etapa es requerida'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/trackings/trackings-model.js